<template>
    <div class="cz2__print-wrapper h-full w-full absolute top-0 bottom-0 left-0 right-0 justify-center bg-white p-4 overflow-visible z-50">
        <div class="flex w-full max-w-6xl mx-auto justify-between flex-wrap lg:flex-nowrap">
            <div class="font-semibold flex flex-col">
                <img
                    class="h-20 mb-8 mt-4"
                    src="../../assets/images/titleist-logo.png"
                >
                <div class="text-2xl whitespace-nowrap flex">
                    {{  $t('YOUR') }}
                    <img
                        class="h-[19px] mx-2 mt-1.5"
                        src="../../assets/images/custom.png"
                    >
                    <!-- Putter(s) ID: ######## -->
                    {{ $t('PUTTERS') }}
                </div>
                <div class="text-2xl">
                    {{ $t('TOTAL_PRICE') }} {{ productPriceCurrent }}/{{ $t('CLUB') }}
                </div>
                <div class="text-2xl whitespace-nowrap">
                    {{  $t('SITE_URL_PRINT_LAYOUT') }}
                </div>
            </div>
            <div class="flex flex-col justify-end">
                <img class="h-[240px] flex-grow-0" :src="previewUrl" alt="Custom putter preview" />
            </div>
        </div>

        <div class="w-full max-w-6xl mx-auto">
            <step-options-summary />
        </div>
    </div>
</template>

<style>
    @media print {
        * {
            overflow: visible !important;
        }
        body { /* required for background colors to print */
            -webkit-print-color-adjust:exact !important;
            print-color-adjust:exact !important;
        }
        @supports (-webkit-touch-callout: none) {
            /* CSS specific to iOS devices */
            .cz2__print-wrapper {
                width: 1080px !important;
            }
        }
    }
</style>

<script>
    import allStores from '../../stores/all';

    import StepOptionsSummary from '../StepOptionsSummary.vue';

    export default {
        mixins: [allStores],

        components: {
            StepOptionsSummary,
        },

        props: {
            groupName: {
                type: String,
                default: '',
            },
        },

        computed: {
            productPriceCurrent() {
                return this.customizerStore.currentPriceFormatted?.current;
            },

            selectionWasMade() {
                return this.customizerStore.selectionsMade.includes(this.groupName);
            },

            isPrintMode() {
                return this.appStore.isPrintMode;
            },

            lastRenderedImage() {
                return this.customizerStore.lastRenderedImage;
            },

            viewController() {
                return this.customizerStore.viewController;
            },

            previewUrl() {
                return this.customizerStore.getPreviewImageUrl(this.viewController);
            },
        },
    };
</script>
